import angular from 'angular';

// Make sure trix is loaded, since the page loads the apex-trix-editor
import "trix"
import "trix/dist/trix.css"

import { TaxNoticeSubmissionListComponent } from './tax-notice-submission-list.component';
import { TaxNoticeDashboardComponent } from './tax-notice-dashboard.component';
import { TaxNoticeRoutingModule } from './tax-notice-routing.module';
import { TaxNoticeService } from '../../core/services/data-services/taxNoticeService';
import { TaxNoticeAssignedListComponent } from './tax-notice-assigned-list.component';
import { ProcessTaxNoticeDashboardComponent } from './process-tax-notice-dashboard.component';
import { ProcessTaxNoticeListComponent } from './process-tax-notice-list.component';
import { ProcessTaxNoticeMyWorkComponent } from './process-tax-notice-my-work.component';
import { ProcessTaxNoticeCompletedComponent } from './process-tax-notice-completed.component';
import { ProcessTaxNoticePendingComponent } from './process-tax-notice-pending.component';
import { TaxNoticeUpdateService } from '../../core/services/data-services/tax-notice-update.service';
import { SharedModule } from '../shared/shared.module'

export const TaxNoticeModule = angular
    .module("apex.mainApp.taxNotice", [
        TaxNoticeRoutingModule,
        SharedModule
    ])
    .component("apexTaxNoticeDashboard", TaxNoticeDashboardComponent)
    .component("apexTaxNoticeSubmissionList", TaxNoticeSubmissionListComponent)
    .component("apexTaxNoticeAssignedList", TaxNoticeAssignedListComponent)
    .component("apexProcessTaxNoticeDashboard", ProcessTaxNoticeDashboardComponent)
    .component("apexProcessTaxNoticeList", ProcessTaxNoticeListComponent)
    .component("apexProcessTaxNoticeMyWork", ProcessTaxNoticeMyWorkComponent)
    .component("apexProcessTaxNoticeCompleted", ProcessTaxNoticeCompletedComponent)
    .component("apexProcessTaxNoticePending", ProcessTaxNoticePendingComponent)
    .service("taxNoticeService", TaxNoticeService)
    .service("taxNoticeUpdateService", TaxNoticeUpdateService)
    .name;
